import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Wrapper = styled.span`
  display: flex;
  padding: 0.4rem 0 0 0;
  flex-direction: column;
`;
